import React from 'react';
import SelectPopup from './SelectPopup';
import { setWorkState } from '../../../service/command';

const modules = [
  'install',
  'froz',
  'work'
];

export default function GotoMode() {
  return (
    <SelectPopup
      title="切换模式"
      label="选择模式："
      modules={modules}
      defaultSelectValue={modules[0]}
      onConfirm={(module) => {
        return setWorkState(module);
      }}
    />
  );
}
